<template>
  <main class="main px-5">
    <h4 class="ml-3">{{ $t("lang.label.attendance_desk") }}</h4>
  <section>
    <LoadingSpinner v-if="loading" />

    <div class="row my-4 px-2" v-if="!loading">
      <!-- Tabla de datos -->
      <div class="col-md-12 w-100 mb-3 card p-2" v-if="!loading">
        <div class="mx-0 px-0 table-responsive">
          <Table
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="meetings"
            :checkbox="false"
            :notselect="true"
            :model="model"
            @goToOpportunity="goToOpportunity"
            @goToClient="goToClient"
          >
          </Table>
        </div>
      </div>
    </div>
  </section>
</main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { linksService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: 'MeetingAttendanceStatus',
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },

  data() {
    return {
      meetings: [],
      loading: true,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
        {
            value: "less_than_1h",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 1,
                label: "STARTS IN < 60 MINUTES",
                bgColor: "#FF0000",
                textColor: "#FFFFFF",
              },
              {
                id: 0,
                label: "STATUS NOT ASSIGNED",
                bgColor: "#ffc107",
                textColor: "#FFFFFF",
              },

            ],
          },       
        ],
        [          
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity"
          }
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          {
            value: "contact_complete_name",
          },
        ],
        [
          {
            value: "contact_phone",
          },
        ],
        [
          {
            value: "bdr_user",
          }
        ],
        [
          {
            value: "event_date",
          },
        ],
      ],
      headers: [
        {
          label: this.$t("lang.label.assign_a_status"),
          percentage: "15%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.orders.meeting"),
          percentage: "20%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: this.$t("lang.label.client"),
          percentage: "15%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: 'Attendee Name',
          percentage: "20%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: 'Attendee Phone',
          percentage: "15%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: 'Booker asign',
          percentage: "15%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: 'Date',
          percentage: "15%",
          class: "overflowhide",
          id: 6,
        },
      ],
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },
  computed: {
    ...mapState({
      headerTab: state => state.header.tab
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  mounted() {
    this.getData();
    this.udpdateHeader('attendance_desk');
  },
  methods: {  
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),  
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    goToClient(client_id) {      
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    goToOpportunity(link_id) {      
      let url = "/opportunities/" + link_id;
      window.open(url, "_blank");
    },
    getData() {
      this.loading = true;

      linksService.getTodayMeetings()
        .then((res) => {
          if (res !== undefined && res) {
            this.meetings = res;
            this.loading = false;
          } else {
            this.meetings = [];
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching today's meetings:", error);
          this.meetings = [];
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>

